// extracted by mini-css-extract-plugin
export default {"icon":"H6nsPkr0bq","hint":"_2CUlrbWrK8"};